import React from 'react'
import { SEO } from '../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import { currencies } from '../../../utils/pages-meta.json'
import CurrencyEditContent from '../../../components/Dashboard/Workspace/CurrencyEditContent'
import { CurrencyProvider } from '../../../CurrencyContext'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { Redirect, useParams } from 'react-router-dom'
import { NamedRoutes } from '../../../routes'

const SingleCurrencyEdit = () => {
  let { id } = useParams()
  const intl = useIntl()

  return (
    <>
      {!!id && !!parseInt(id) ? <>
        <SEO title={intl.formatMessage({ id: 'Currencies.Form.EditTitle' })}
          pathname={window.location.origin}
          titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
          image={currencies.image}
          description={intl.formatMessage({ id: 'Currencies.Form.EditTitle' })}
        />
        <AuthenticatedUserConsumer>
          {({ userDataLoading, userData, handleNotificationCall }) => (
            <>
              {!!userDataLoading && <FormLoader loading={true} />}
              {!!Object.keys(userData).length &&
                <>
                  {!!userData.is_admin ? <Layout content={
                    <CurrencyProvider isEdit currencyId={id}
                      handleNotificationCall={handleNotificationCall}>
                      <CurrencyEditContent pageTitle={<FormattedMessage id='Currencies.Form.EditTitle' />} />
                    </CurrencyProvider>
                  } /> : (!userDataLoading && <Redirect to={NamedRoutes.home} />)
                  }
                </>
              }
            </>
          )}
        </AuthenticatedUserConsumer>
      </> :
        <Redirect to={NamedRoutes.workspace.currencies.list} />
      }
    </>
  )
}

export default SingleCurrencyEdit

